import React from 'react';
import { Box, IconButton } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, ChevronDownIcon } from '@chakra-ui/icons';

interface NavigationArrowsProps {
  onRotate: (direction: 'left' | 'right' | 'up' | 'down') => void;
  isRotating: boolean;
}

const NavigationArrows: React.FC<NavigationArrowsProps> = ({ onRotate, isRotating }) => {
  return (
    <>
      {/* Left Arrow */}
      <IconButton
        aria-label="Rotate Left"
        icon={<ChevronLeftIcon />}
        position="absolute"
        left="-50px"
        top="50%"
        transform="translateY(-50%)"
        onClick={() => onRotate('left')}
        isDisabled={isRotating}
      />

      {/* Right Arrow */}
      <IconButton
        aria-label="Rotate Right"
        icon={<ChevronRightIcon />}
        position="absolute"
        right="-50px"
        top="50%"
        transform="translateY(-50%)"
        onClick={() => onRotate('right')}
        isDisabled={isRotating}
      />

      {/* Top Arrow */}
      <IconButton
        aria-label="Rotate Up"
        icon={<ChevronUpIcon />}
        position="absolute"
        top="-50px"
        left="50%"
        transform="translateX(-50%)"
        onClick={() => onRotate('up')}
        isDisabled={isRotating}
        style={{marginTop: '15px'}}
      />

      {/* Bottom Arrow */}
      <IconButton
        aria-label="Rotate Down"
        icon={<ChevronDownIcon />}
        position="absolute"
        bottom="-50px"
        left="50%"
        transform="translateX(-50%)"
        onClick={() => onRotate('down')}
        isDisabled={isRotating}
        style={{marginBottom: '10px'}}

      />
    </>
  );
};

export default NavigationArrows;